<template>

</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)


export default {

  existsUserLogin (self) {
    self.userinfo = self.$cookies.get('userinfo')
    if (self.userinfo === null || self.userinfo === undefined) {
      self.$router.push({ name: 'login' })
    }
    else {
      self.$ajax.post(self.constant.openPaths.existsSingleLogin,
        {
          UserId: self.userinfo.id,
          LoginToken: self.userinfo.loginToken
        }
      ).then(function (res) {
        if (res.data.code === 200) {
          self.$cookies.set('userinfo', res.data.result, 60 * 60 * 2)
          self.userinfo = res.data.result
        }
        else {
          self.$message.error('登录失效')
          self.$router.push({ name: 'login' })
        }
      }).catch(function (error) {
        self.$message.error(error)
      })
    }
  },
  getAjaxRequest (self, url, result) {
    if (sessionStorage.getItem(result) === null || sessionStorage.getItem(result) === undefined) {
      self.$ajax.get(url).then(res => {
        if (res.data.code === 200) {
          self[result] = res.data.result
          sessionStorage.setItem(result, JSON.stringify(res.data.result))
        }
        else {
          self.$message.error(res.data.msg)
        }
      }).catch(error => { self.$message.error(error) })
    }
    else {
      self[result] = JSON.parse(sessionStorage.getItem(result))
    }
  },
  postAjaxRequest (self, url, data, result) {
    if (self.userinfo !== null && self.userinfo !== undefined) {
      self.$ajax.post(url, data).then(res => {
        switch (res.data.code) {
          case 200:
            self[result] = res.data.result
            return result
            break;
          case 402:
            self.$router.push({ name: 'login' })
            break
          default:
            self.$message.error(res.data.msg)
            break;
        }
      })
    }
    else {
      self.$router.push({ name: 'index' })
    }
  },
  initCountry (self) {
    var result = []
    self.$ajax.get(self.constant.openPaths.getCountryList).then(res => {
      if (res.data.code === 200) {
        result = res.data.result
      }
      else {
        self.$message.error(res.data.msg)
      }
    }).catch(error => { self.$message.error(error) })
    return result
  },
  initAirportList (self) {
    var result = []
    self.$ajax.get(self.constant.openPaths.getAirportList).then(res => {
      if (res.data.code === 200) {
        result = res.data.result
      }
      else {
        self.$message.error(res.data.msg)
      }
    }).catch(error => { self.$message.error(error) })
    return result
  },
}
</script>



// WEBPACK FOOTER //
// src/common/common.vue